import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import Icon from 'components/patterns/Icon'
import 'styles/CollapsibleWidget.css'

class CollapsibleWidget extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      dragOver: false,
      collapsed: props.collapsed === false ? false : !props.noCollapse,
    }
    this.ref = null
  }

  componentDidUpdate() {
    const { unCollapse, noCollapse } = this.props
    const { collapsed } = this.state
    if (unCollapse && !noCollapse && collapsed === true) {
      this.setState({ collapsed: false })
    }
  }

  toggleCollapse = () => {
    const { noCollapse, children, enabled } = this.props
    if (noCollapse) return
    if (React.Children.count(children) > 0 && enabled) {
      this.setState((lastState) =>
        Object.assign({}, lastState, {
          collapsed: !lastState.collapsed,
        })
      )
    }
  }

  handleDragEnter = () => {
    const { headerHoverDelay } = this.props
    this.setState({ dragOver: true })
    this.ref = setTimeout(() => {
      if (this.state.dragOver) {
        this.toggleCollapse()
      }
    }, headerHoverDelay)
  }

  handleDragLeave = () => {
    clearTimeout(this.ref)
    this.setState({ dragOver: false })
  }

  render() {
    const {
      className,
      lights,
      removed,
      nested,
      enabled,
      title,
      noCollapse,
      children,
      headerButton,
      unCollapse,
      enableToggleOnDrag,
    } = this.props
    const collapsed =
      this.state.collapsed || React.Children.count(children) === 0
    let icon

    if (className && className.includes('box')) {
      icon = collapsed ? 'FaCaretDown' : 'FaMinus'
    } else {
      icon = collapsed ? 'FaCaretRight' : 'FaCaretDown'
    }

    return (
      <div className={`collapsible-widget ${className || ''}`}>
        {lights.map((light) => {
          const color = typeof light === 'string' ? light : light.color
          const onClick =
            typeof light === 'object' && light.onClick
              ? (event) => {
                  event.stopPropagation()
                  light.onClick()
                }
              : null
          return (
            <div
              key={color}
              className={`collapsible-widget_light collapsible-widget_light--${color}`}
              onClick={onClick}
            >
              {light.icon}
            </div>
          )
        })}
        {!unCollapse && (
          <StyledHeader
            isOnDrag={this.state.dragOver}
            onDragOver={() => {
              if (!this.state.dragOver) this.setState({ dragOver: true })
            }}
            onDragExit={() => this.setState({ dragOver: false })}
            onDragEnter={enableToggleOnDrag ? this.handleDragEnter : undefined}
            onDragLeave={enableToggleOnDrag ? this.handleDragLeave : undefined}
            className={`collapsible-widget_header${removed ? '-removed' : ''}`}
          >
            <div>
              {!noCollapse && (
                <div
                  className="collapsible-widget_toggle"
                  onClick={this.toggleCollapse}
                >
                  <Icon
                    icon={icon}
                    height={nested ? 15 : undefined}
                    width={nested ? 15 : undefined}
                    disabled={!enabled}
                    className="collapsible-widget_toggle"
                  />
                </div>
              )}
              {nested ? (
                <h3
                  onClick={this.toggleCollapse}
                  className={`collapsible-widget_nested-title${
                    React.Children.count(children) < 1
                      ? '-disabled'
                      : removed
                      ? '-removed'
                      : ''
                  }`}
                >
                  {title}
                </h3>
              ) : (
                <h3
                  onClick={this.toggleCollapse}
                  className={`collapsible-widget_title${
                    enabled ? '' : '-disabled'
                  }`}
                >
                  {title}
                </h3>
              )}
            </div>
            {headerButton && (
              <div className="collapsible-widget_header-button">
                {headerButton}
              </div>
            )}
          </StyledHeader>
        )}
        {!collapsed && (
          <div className="collapsible-widget_content">{children}</div>
        )}
      </div>
    )
  }
}

CollapsibleWidget.defaultProps = {
  lights: [],
  enabled: true,
  headerHoverDelay: 1000,
  enableToggleOnDrag: false,
}

CollapsibleWidget.propTypes = {
  title: PropTypes.node,
  collapsed: PropTypes.bool,
  nested: PropTypes.bool,
  enabled: PropTypes.bool,
  children: PropTypes.any,
  lights: PropTypes.arrayOf(
    PropTypes.oneOfType([PropTypes.string, PropTypes.object])
  ),
  className: PropTypes.string,
  removed: PropTypes.bool,
  noCollapse: PropTypes.bool,
  unCollapse: PropTypes.bool,
  headerButton: PropTypes.node,
  headerHoverDelay: PropTypes.number,
  enableToggleOnDrag: PropTypes.bool,
}

export default CollapsibleWidget

const StyledHeader = styled.div((props) => {
  const { isOnDrag } = props
  return `
    h4 {
      opacity: ${isOnDrag ? `0.6` : `1`};
    }
  `
})
